export default __webpack_public_path__ + "static/media/p1_xplaUpdate.24890e70.png";